import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, IcoClose, ModalRight } from '../../components';
import { setCloseCentralAjuda } from '../centralAjuda/redux/centralAjudaActions';

// Host público da Central de Ajuda para o dashboard compartilhado
export default function CentralAjudaPublicHost({ idioma }) {

  const dispatch = useDispatch();

  const { centralAjuda, open } = useSelector(
    (s) => s.centralAjudaState || { centralAjuda: [], open: false }
  );

  // Carrega NLS da Central de Ajuda conforme idioma do dashboard
  const nlsAjuda = useMemo(() => {
    try {
      return require(`../centralAjuda/nls/${idioma}.json`);
    } catch {
      try {
        return require(`../centralAjuda/nls/pt-BR.json`);
      } catch {
        return { title: 'Ajuda' };
      }
    }
  }, [idioma]);

  // Altura do modal baseada na viewport
  const style = useMemo(() => {
    const h = typeof window !== 'undefined' ? window.innerHeight : 800;
    return {
      maxHeight: `${h}px`,
      maxWidth: '260px',
      width: '100%',
      top: '0px'
    };
  }, []);

  const heigthModal = useMemo(() => {
    const h = typeof window !== 'undefined' ? window.innerHeight : 800;
    return {
      maxHeight: `calc(${h - 72}px)`
    };
  }, []);

  if (!open) return null;

  return (
    <ModalRight
      style={style}
      open={open}
    >
      <div className='box-central-ajuda'>

        <div className='box-central-ajuda-title'>

          <h4>{nlsAjuda.title}</h4>

          <Button
            type='link'
            onClick={() => dispatch(setCloseCentralAjuda())}
          >
            <IcoClose />
          </Button>

        </div>

        <div
          className='box-central-ajuda-content'
          style={heigthModal}
        >

          {(centralAjuda || []).map((e) => (

            <div
              key={e.id}
              className='box-central-ajuda-content-info'
            >

              <h6
                className='custom-spacing'
                style={{ color: 'rgb(50, 58, 204)' }}
                dangerouslySetInnerHTML={{ __html: e.titulo }}
              />

              <p
                className='custom-spacing textosite'
                dangerouslySetInnerHTML={{ __html: e.conteudo }}
              />

            </div>

          ))}

        </div>

      </div>

    </ModalRight>
  );
}
